<template>
  <div>
    <v-container class="mt-3">
      <v-layout row justify-center mt-5 pb-5>
        <v-flex xs12 md8>
          <v-card class="defaultCardClass" flat>
            <v-card-title
              class="text-center pt-6 pb-0 px-6 justify-center align-center"
            >
            {{$t('title.Thanks')}}
          </v-card-title>
            <v-card-title
              class="text-center pt-6 pb-0 px-6 justify-center align-center"
            >
              <v-text-field
                v-model="name"
                :label="$t('labels.names')"
                v-on:keyup.enter="getContent"
                outlined
                rounded
              >
                <template v-slot:append>
                  <v-btn
                    text
                    :disabled="name.length < 3"
                    color="primary"
                    @click="getContent"
                    class="text-capitalize"
                    style="margin-top: -7px"
                  >
                    {{ $t("buttons.search") }}
                  </v-btn>
                </template>
              </v-text-field>
            </v-card-title>

            <v-card-title class="pt-0 pb-0 px-0">
              <loading-progress :status="loadingList" />
              <v-list
                subheader
                two-line
                style="
                  background-color: transparent !important;
                  width: 100%;
                  overflow-y: scroll;
                  height: calc(100vh - 290px);
                "
              >
                <div
                  v-for="(item, index) in data"
                  :key="item.Id.concat(index.toString())"
                >
                  <user-list-item
                    :item="item"
                    :avatar="item.Avatar"
                    :fullName="item.FullName"
                    :department="item.Department"
                    :company="item.Company"
                    :noBg="true"
                    :divider="data.length == index + 1 ? false : true"
                    :buttonVisible="true"
                    :buttonText="$t('buttons.thanks')"
                    :buttonDisabled="false"
                    :userId="item.Id"
                    @sendMessage="(n) => thanksUser(n)"
                  />
                </div>
              </v-list>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import UserService from "@/services/UserService";
import NotificationService from "@/services/NotificationService";
import UserListItem from "../../components/Users/UserListItem.vue";
import LoadingProgress from "../../components/General/LoadingProgress.vue";

export default {
  data: function () {
    {
      return {
        data: [],
        loadingList: false,
        name: "",
        disabled: false
      };
    }
  },
  components: {
    UserListItem,
    LoadingProgress,
  },
  methods: {
    getContent() {
      this.loadingList = true;
      this.data = []
      UserService.getUsers(this.name)
        .then((res) => {
          this.data = res.data.Data;
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.loadingList = false;
        });

    },

    thanksUser(item) {
      UserService.postEndorsement({UserId: item.Id})
        .then((res) => {
          this.sendNotification(item)
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
        });
    },

    sendNotification(item){
      NotificationService.sendNotification(
        item.Username,
        "tesekkur_et"
      )
        .then((res) => {
          showSuccess(this.$t('description.sendThanks'));
        })
        .catch((err) => {
          showError(err);
        });
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
  },
  watch: {},
};
</script>
